import { ESearchFilters } from '@/constants/searchFilters';
import { mapRentalToTile } from '@/utility/mapSearchResultToTile';

export const formatQueryParams = (queryParams?: string) => {
  if (!queryParams) return;

  const urlParams = new URLSearchParams(queryParams);
  if (urlParams.has('delivery_stationary')) {
    const value = urlParams.get('delivery_stationary');
    if (value) {
      urlParams.set(ESearchFilters.DELIVERY_STATIONARY, value);
    }
    urlParams.delete('delivery_stationary');
  }
  if (urlParams.has('delivery_address')) {
    const value = urlParams.get('delivery_address');
    if (value) {
      urlParams.set(ESearchFilters.DELIVERY_ADDRESS, value);
    }
    urlParams.delete('delivery_address');
  }
  if (urlParams.has(ESearchFilters.PAGE_LIMIT)) {
    urlParams.delete(ESearchFilters.PAGE_LIMIT);
  }

  return urlParams.toString();
};

export const formatRentalTiles = (tiles?: unknown[]) => {
  return tiles?.map((rental: unknown, index: number) =>
    mapRentalToTile({
      rental: rental as any,
      index,
      favorites: { rentals: [], escapes: [] },
    }),
  );
};
